import { Navigate, type RouteObject } from "react-router-dom";
import AccountDeletionPage from "../pages/account-deletion/page";
import NotFound from "../pages/NotFound";
import AdminLogin from "../pages/admin/login/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import LifeSignalPage from "../pages/admin/life-signal/page";
import DailySchedulesPage from "../pages/admin/daily-schedules/page";
import SoundAnalysisPage from "../pages/admin/sound-analysis/page";
import SoundAnalysisDetailPage from "../pages/admin/sound-analysis-detail/page";
import EafrSoundEventsPage from "../pages/admin/eafr-sound-events/page";
import EafrSoundEventDetailPage from "../pages/admin/eafr-sound-event-detail/page";
import SoundRawAudioReviewsPage from "../pages/admin/sound-raw-audio-reviews/page";
import SoundRawAudioReviewDetailPage from "../pages/admin/sound-raw-audio-review-detail/page";
import SoundDatasetSamplesPage from "../pages/admin/sound-dataset-samples/page";
import SoundModelReleasesPage from "../pages/admin/sound-model-releases/page";
import SoundModelMappingRulesPage from "../pages/admin/sound-model-mapping-rules/page";
import SeniorDetailPage from "../pages/admin/senior-detail/page";
import DevicesPage from "../pages/admin/devices/page";
import AdminEmergencyPage from "../pages/admin/emergency/page";
import LocationPage from "../pages/admin/location/page";
import LocationDetailPage from "../pages/admin/location-detail/page";
import MembersPage from "../pages/admin/members/page";
import FamilyConnectionsPage from "../pages/admin/family-connections/page";
import FamilyConnectionDetailPage from "../pages/admin/family-connection-detail/page";
import SettingsPage from "../pages/admin/settings/page";
import AuditLogsPage from "../pages/admin/audit-logs/page";
import MembershipsPage from "../pages/admin/memberships/page";
import CustomerInquiriesPage from "../pages/admin/customer-inquiries/page";
import TermsPage from "../pages/admin/terms/page";
import TermsDetailPage from "../pages/admin/terms-detail/page";
import PublicTermsPage from "../pages/terms/page";
import PublicTermsDetailPage from "../pages/terms-detail/page";
import AdminRouteGuard from "./AdminRouteGuard";
import LegacySeniorDetailRedirect from "./LegacySeniorDetailRedirect";
import LegacyLifeSignalDetailRedirect from "./LegacyLifeSignalDetailRedirect";

const routes: RouteObject[] = [
  { path: "/account-deletion", element: <AccountDeletionPage /> },
  { path: "/admin/memberships", element: <AdminRouteGuard><MembershipsPage /></AdminRouteGuard> },
  {
    path: "/terms",
    element: <PublicTermsPage />,
  },
  {
    path: "/terms/:termsTypeCode",
    element: <PublicTermsDetailPage />,
  },
  {
    path: "/",
    element: <Navigate to="/admin/login" replace />,
  },
  {
    path: "/admin",
    element: <Navigate to="/admin/login" replace />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin/dashboard",
    element: <AdminRouteGuard><AdminDashboard /></AdminRouteGuard>,
  },
  {
    path: "/admin/emergency",
    element: <AdminRouteGuard><AdminEmergencyPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/life-signal",
    element: <AdminRouteGuard><LifeSignalPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/life-signal/:seniorUserAccountId",
    element: <AdminRouteGuard><LegacyLifeSignalDetailRedirect /></AdminRouteGuard>,
  },
  {
    path: "/admin/daily-schedules",
    element: <AdminRouteGuard><DailySchedulesPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/eafr-sound-events",
    element: <AdminRouteGuard><EafrSoundEventsPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/eafr-sound-events/:eventId",
    element: <AdminRouteGuard><EafrSoundEventDetailPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/sound-analysis",
    element: <AdminRouteGuard><SoundAnalysisPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/sound-analysis/:recordId",
    element: <AdminRouteGuard><SoundAnalysisDetailPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/sound-raw-audio-reviews",
    element: <AdminRouteGuard><SoundRawAudioReviewsPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/sound-raw-audio-reviews/:eventId",
    element: <AdminRouteGuard><SoundRawAudioReviewDetailPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/sound-dataset-samples",
    element: <AdminRouteGuard><SoundDatasetSamplesPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/sound-model-releases",
    element: <AdminRouteGuard><SoundModelReleasesPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/sound-model-mapping-rules",
    element: <AdminRouteGuard><SoundModelMappingRulesPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/location",
    element: <AdminRouteGuard><LocationPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/location/:seniorUserAccountId",
    element: <AdminRouteGuard><LocationDetailPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/users",
    element: <AdminRouteGuard><MembersPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/users/seniors/:seniorUserAccountId",
    element: <AdminRouteGuard><SeniorDetailPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/devices",
    element: <AdminRouteGuard><DevicesPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/members",
    element: <Navigate to="/admin/users" replace />,
  },
  {
    path: "/admin/senior-accounts/:seniorUserAccountId",
    element: <LegacySeniorDetailRedirect />,
  },
  {
    path: "/admin/family-connections",
    element: <AdminRouteGuard><FamilyConnectionsPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/family-connections/:seniorUserAccountId",
    element: <AdminRouteGuard><FamilyConnectionDetailPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/customer-inquiries",
    element: <AdminRouteGuard><CustomerInquiriesPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/terms",
    element: <AdminRouteGuard><TermsPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/terms/:termsPolicyId",
    element: <AdminRouteGuard><TermsDetailPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/audit-logs",
    element: <AdminRouteGuard><AuditLogsPage /></AdminRouteGuard>,
  },
  {
    path: "/admin/settings",
    element: <AdminRouteGuard><SettingsPage /></AdminRouteGuard>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
